// extracted by mini-css-extract-plugin
export default {"flag":"InternationalExposureFlag_flag__9-U+O"};